import { type App } from 'vue'
import AppBadge from './app-badge.vue'
import AppButton from './app-button.vue'
import AppCheckbox from './app-checkbox.vue'
import AppDropdown from './app-dropdown.vue'
import AppEmpty from './app-empty.vue'
import AppErrorMsg from './app-error-msg.vue'
import AppFilterBarItem from './app-filter-bar-item.vue'
import AppForm from './app-form.vue'
import AppFormSection from './app-form-section.vue'
import AppImage from './app-image.vue'
import AppInput from './app-input.vue'
import AppInputFile from './app-input-file.vue'
import AppInputNumber from './app-input-number.vue'
import AppInputPassword from './app-input-password.vue'
import AppNotice from './app-notice.vue'
import AppPagination from './app-pagination.vue'
import AppRadio from './app-radio.vue'
import AppRouterView from './app-router-view.vue'
import AppSearch from './app-search.vue'
import AppSearchPage from './app-search-page.vue'
import AppSelect from './app-select.vue'
import AppSubmit from './app-submit.vue'
import AppSwitch from './app-switch.vue'
import AppTabStatus from './app-tab-status.vue'
import AppTabStatusItem from './app-tab-status-item.vue'
import AppTableColMoney from './app-table-col-money.vue'
import AppTableInfo from './app-table-info.vue'
import AppTableInfoRow from './app-table-info-row.vue'
import Card from './card'
import CropperJS from './cropperjs'
import AppDatePicker from './datepicker/app-date-picker.vue'
import AppDateRangePicker from './datepicker/app-date-range-picker.vue'
import AppInputDate from './datepicker/app-input-date.vue'
import FaIcon from './fa-icon.vue'
import Modal from './modal'
import AppSubmenu from './submenu/app-submenu.vue'
import AppSubmenuItem from './submenu/app-submenu-item.vue'
import AppTable from './table/app-table.vue'
import AppTableCheckable from './table/app-table-checkable.vue'

export default {
  install (app: App) {
    app.component('AppBadge', AppBadge)
    app.component('AppButton', AppButton)
    app.component('AppCheckbox', AppCheckbox)
    app.component('AppDatePicker', AppDatePicker)
    app.component('AppDateRangePicker', AppDateRangePicker)
    app.component('AppDropdown', AppDropdown)
    app.component('AppErrorMsg', AppErrorMsg)
    app.component('AppEmpty', AppEmpty)
    app.component('AppFilterBarItem', AppFilterBarItem)
    app.component('AppForm', AppForm)
    app.component('AppFormSection', AppFormSection)
    app.component('AppImage', AppImage)
    app.component('AppInput', AppInput)
    app.component('AppInputDate', AppInputDate)
    app.component('AppInputFile', AppInputFile)
    app.component('AppInputNumber', AppInputNumber)
    app.component('AppInputPassword', AppInputPassword)
    app.component('AppNotice', AppNotice)
    app.component('AppPagination', AppPagination)
    app.component('AppRadio', AppRadio)
    app.component('AppRouterView', AppRouterView)
    app.component('AppSearch', AppSearch)
    app.component('AppSearchPage', AppSearchPage)
    app.component('AppSelect', AppSelect)
    app.component('AppSubmenu', AppSubmenu)
    app.component('AppSubmenuItem', AppSubmenuItem)
    app.component('AppSubmit', AppSubmit)
    app.component('AppSwitch', AppSwitch)
    app.component('AppTable', AppTable)
    app.component('AppTableColMoney', AppTableColMoney)
    app.component('AppTableInfo', AppTableInfo)
    app.component('AppTableInfoRow', AppTableInfoRow)
    app.component('AppTableCheckable', AppTableCheckable)
    app.component('AppTabStatus', AppTabStatus)
    app.component('AppTabStatusItem', AppTabStatusItem)
    app.component('FaIcon', FaIcon)
    app.use(Modal)
    app.use(Card)
    app.use(CropperJS)
  },
}

declare module 'vue' {
  export interface GlobalComponents {
    AppBadge: typeof AppBadge,
    AppButton: typeof AppButton,
    AppCheckbox: typeof AppCheckbox,
    AppDropdown: typeof AppDropdown,
    AppDatePicker: typeof AppDatePicker,
    AppDateRangePicker: typeof AppDateRangePicker,
    AppErrorMsg: typeof AppErrorMsg,
    AppEmpty: typeof AppEmpty,
    AppFilterBarItem: typeof AppFilterBarItem,
    AppForm: typeof AppForm,
    AppFormSection: typeof AppFormSection,
    AppImage: typeof AppImage,
    AppInput: typeof AppInput,
    AppInputDate: typeof AppInputDate,
    AppInputFile: typeof AppInputFile,
    AppInputNumber: typeof AppInputNumber,
    AppInputPassword: typeof AppInputPassword,
    AppNotice: typeof AppNotice,
    AppPagination: typeof AppPagination,
    AppRadio: typeof AppRadio,
    AppRouterView: typeof AppRouterView,
    AppSearch: typeof AppSearch,
    AppSearchPage: typeof AppSearchPage,
    AppSelect: typeof AppSelect,
    AppSubmenu: typeof AppSubmenu,
    AppSubmenuItem: typeof AppSubmenuItem,
    AppSubmit: typeof AppSubmit,
    AppSwitch: typeof AppSwitch,
    AppTableColMoney: typeof AppTableColMoney,
    AppTable: typeof AppTable,
    AppTableCheckable: typeof AppTableCheckable,
    AppTableInfo: typeof AppTableInfo,
    AppTableInfoRow: typeof AppTableInfoRow,
    AppTabStatus: typeof AppTabStatus,
    AppTabStatusItem: typeof AppTabStatusItem,
    FaIcon: typeof FaIcon,
  }
}
